"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M47.323 25.414L36.845 36.059a1.947 1.947 0 0 1-2.784 0l-.278-.282a2.029 2.029 0 0 1 0-2.828L42.59 24l-8.807-8.949a2.029 2.029 0 0 1 0-2.828l.278-.282a1.947 1.947 0 0 1 2.784 0l10.478 10.644a2.023 2.023 0 0 1 0 2.829zM.677 22.585L11.155 11.94a1.947 1.947 0 0 1 2.784 0l.278.282a2.029 2.029 0 0 1 0 2.828L5.41 24l8.807 8.949a2.029 2.029 0 0 1 0 2.828l-.278.282a1.947 1.947 0 0 1-2.784 0L.677 25.414a2.023 2.023 0 0 1 0-2.829zM21.73 39.359c-.045.18-.135.225-.315.225h-3.73c-.225 0-.27-.09-.225-.27l8.854-32.939c.045-.18.09-.18.27-.18h3.775c.18 0 .225.045.18.225z" })
);

